import { iniciais } from '@nexital/shared';

// Cor estável por pessoa (a mesma pessoa tem sempre a mesma cor).
const CORES = ['#5B4CF0', '#1E9BD7', '#22B35E', '#E07B1A', '#E5484D', '#7C7891', '#2F6FDB', '#B5469B'];

function corDe(chave: string) {
  const soma = [...chave].reduce((total, c) => total + c.charCodeAt(0), 0);
  return CORES[soma % CORES.length];
}

export function Avatar({ nome, chave, tamanho = 26, url }: { nome: string; chave: string; tamanho?: number; url?: string | null }) {
  if (url) {
    return <img className="avatar avatar--foto" src={url} alt={nome} title={nome} width={tamanho} height={tamanho} style={{ width: tamanho, height: tamanho }} />;
  }
  return (
    <span
      className="avatar"
      style={{ width: tamanho, height: tamanho, fontSize: tamanho * 0.4, background: corDe(chave) }}
      title={nome}
      aria-label={nome}
    >
      {iniciais(nome)}
    </span>
  );
}
